import React from 'react';
import { Container } from 'react-bootstrap';

const OutsourcingVsFull6 = props => {
    return (
        <section id="outsourcing-vs-full-section6" className="my pt-5 white-bg">
            <Container>
                <div className="title-triangle top-md fw-600"></div>
                <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingVsFull:section-6.title')}</h2>
                <p className='mb-4'>{props.t('services:outsourcingVsFull:section-6.txt')}</p>
                <ul className='mb-4'>
                    {props.t('services:outsourcingVsFull:section-6.list', { returnObjects: true }).map((item, index) => (
                        <li key={index}><p className='m-0'>{item}</p></li>
                    ))}
                </ul>
                <p className='m-0'>{props.t('services:outsourcingVsFull:section-6.text')}</p>
            </Container>
        </section>
    );
};

export default OutsourcingVsFull6;
